import { useMutation, useQuery } from "@tanstack/react-query";
import { useCallback, useEffect, useRef, useState } from "react";
import queryKey from "../../../enumerations/queryKey";
import {
  apiGetUserAreaCode,
  apiGetUserForgetSendVerify,
  apiPostUserMobileSend,
  apiPostUserMobileVerify,
  apiPutUserForgetPassword,
} from "../service";
import { resolveDefaultAreaCode } from "../utils/resolveDefaultAreaCode";

export const usePostMobileSend = (options) => {
  return useMutation(
    (params) =>
      apiPostUserMobileSend(params).then((res) => {
        return res.data.data;
      }),
    {
      onError: (error) => {
        console.debug(JSON.stringify("ERR", error));
      },
    },
  );
};
export const useGetUserForgetSendVerify = (options) => {
  return useMutation(
    (params) =>
      apiGetUserForgetSendVerify(params).then((res) => {
        return res.data.data;
      }),
    {
      onError: (error) => {
        console.debug(JSON.stringify("ERR", error));
      },
    },
  );
};
export const usePostMobileVerify = (options = { onSuccess: () => {} }) => {
  return useMutation(
    (params) =>
      apiPostUserMobileVerify(params).then((res) => {
        return res.data.data;
      }),
    {
      onError: (error) => {
        console.debug(JSON.stringify("ERR", error));
      },
      onSuccess: options.onSuccess,
    },
  );
};

export const useGetUserAreaCode = (options) => {
  return useQuery(
    [queryKey.USER_AREA_CODE],
    () => apiGetUserAreaCode().then((res) => res.data.data),
    {
      ...options,
    },
  );
};

export const useResolveDefaultAreaCode = (areaCodeList, enabled) => {
  const [areaCodeSelected, setAreaCodeSelected] = useState();
  const hasUserSelectedRef = useRef(false);

  const setAreaCodeSelectedByUser = useCallback((code) => {
    hasUserSelectedRef.current = true;
    setAreaCodeSelected(code);
  }, []);

  useEffect(() => {
    if (!enabled || !areaCodeList?.length) return;

    hasUserSelectedRef.current = false;
    let cancelled = false;

    const resolve = async () => {
      const resolved = await resolveDefaultAreaCode(areaCodeList);
      if (!cancelled && !hasUserSelectedRef.current) {
        setAreaCodeSelected(resolved);
      }
    };

    resolve();

    return () => {
      cancelled = true;
    };
  }, [enabled, areaCodeList]);

  return {
    areaCodeSelected,
    setAreaCodeSelected: setAreaCodeSelectedByUser,
  };
};

export const usePutForgetPassword = (options = { onSuccess: () => {} }) => {
  return useMutation(
    (params) =>
      apiPutUserForgetPassword(params).then((res) => {
        return res.data.data;
      }),
    {
      onError: (error) => {
        console.debug(JSON.stringify("ERR", error));
      },
      onSuccess: options.onSuccess,
    },
  );
};
